import React from 'react';
import { REGISTRATION_FORM_URL } from '../constants/links';

const NoticeStrip: React.FC = () => {
  return (
    <p className="notice-strip">
      <span className="notice-strip__tag">Inscripciones</span>
      <a
        href={REGISTRATION_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="notice-strip__link"
      >
        II Cumbre Nacional — Lima, 13 y 14 de noviembre
      </a>
    </p>
  );
};

export default NoticeStrip;
